import React from 'react';

import MetaButtons from 'src/components/MetaButtons/MetaButtons';
import { ConsumptionPageTypes } from 'src/types/consumption';
import { ContentItemType } from 'src/utils/commonTypes';

// import SocialButton, { SocialButtonProps } from './SocialButton';
import * as customStyled from './styles';

interface SocialButtonsProps extends ConsumptionPageTypes.CommonUIProps {
  assetInformation: ContentItemType;
  getSinglePlayDetails: (spApiObject: any) => void;
  handleCommerceLayout?: () => void;
  singlePlayData: any;
}

const SocialButtons: React.FC<SocialButtonsProps> = ({
  assetInformation,
  getSinglePlayDetails,
  handleCommerceLayout,
  singlePlayData,
  spaceX,
  spaceY
}) => {
  return (
    <div
      css={customStyled.iconsWrapper(spaceX as string, spaceY as string)}
      data-testid="social-btnIcons-wrapper">
      <MetaButtons
        getSinglePlayDetails={getSinglePlayDetails}
        handleCommerceLayout={handleCommerceLayout}
        singlePlayData={singlePlayData}
        metaButtonItems={assetInformation}
      />
    </div>
  );
};

export default SocialButtons;
